export default __webpack_public_path__ + "static/media/magnifier.147a6ed0.svg";